export default function Testimonials() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-8 lg:px-16 bg-background-50">
      <div className="flex flex-col lg:flex-row gap-0">
        <div className="flex-1 flex flex-col justify-center py-8 md:py-12 pr-0 lg:pr-12">
          <div className="flex items-center gap-2 mb-8">
            <span className="w-2 h-2 rounded-full bg-foreground-950"></span>
            <span className="text-xs font-semibold text-foreground-700 uppercase tracking-widest whitespace-nowrap">
              Avis Vérifié
            </span>
          </div>

          <blockquote className="font-heading text-2xl md:text-3xl lg:text-4xl font-medium text-foreground-950 leading-snug italic">
            &ldquo;Le <strong>hipobuy spreadsheet</strong> a complètement transformé ma façon de gérer mes produits. J'ai réduit mon temps d'analyse de 60% et mes marges ont augmenté de 25%.&rdquo;
          </blockquote>

          <div className="mt-6 flex items-center gap-3">
            <span className="text-sm font-semibold text-foreground-950 whitespace-nowrap">Marie Laurent</span>
            <span className="text-accent-500 text-sm">★★★★★</span>
            <span className="text-xs text-foreground-400 whitespace-nowrap">Vendeuse Shopify vérifiée</span>
          </div>
        </div>

        <div className="flex-1 relative min-h-[400px] lg:min-h-[500px] bg-background-100 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20a%20woman%20in%20cream%20linen%20shirt%20sitting%20at%20wooden%20cafe%20table%20with%20laptop%2C%20soft%20afternoon%20sunlight%20through%20large%20window%2C%20natural%20minimal%20interior%2C%20Scandinavian%20editorial%20portrait%20photography%2C%20gentle%20warm%20amber%20and%20cream%20tones%2C%20authentic%20relaxed%20expression&width=700&height=900&seq=testimonial-v3f&orientation=portrait"
            alt="Témoignage utilisateur hipobuy spreadsheet"
            title="Avis hipobuy spreadsheet"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}